// カートドロワー内のおすすめカード（snippets/botarhythm-cart-rec-card.liquid）の容量ピルと「＋」ボタン。
// ドロワーは再描画で中身が丸ごと入れ替わるため、document への委譲で 1 回だけ登録する。
(() => {
  if (window.__btCartRecsBound) return;
  window.__btCartRecsBound = true;

  const loc = (document.documentElement.lang || 'ja').slice(0, 2);
  const failText = loc === 'en'
    ? 'Could not add this item. Please try again from the product page.'
    : loc === 'zh'
      ? '无法加入购物车。请从商品页面重试。'
      : 'カートに追加できませんでした。商品ページからお試しいただけます。';
  const yen = (cents) => '¥' + Math.round(cents / 100).toLocaleString('ja-JP');

  // 容量ピル: 選んだ容量に合わせて、価格表示と「＋（挽き方）」が追加するバリアントを切り替える
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-bt-size]');
    if (!pill || pill.disabled) return;
    const card = pill.closest('.bt-cart-recs__item');
    if (!card) return;
    let variants = [];
    try { variants = JSON.parse(card.dataset.btVariants || '[]'); } catch (_) { return; }
    const size = pill.dataset.btSize;

    card.querySelectorAll('[data-bt-size]').forEach((p) => p.setAttribute('aria-pressed', String(p === pill)));
    let shown = null;
    card.querySelectorAll('[data-bt-grind]').forEach((btn) => {
      const v = variants.find((x) => x.o1 === btn.dataset.btGrind && x.o2 === size);
      if (!v) { btn.disabled = true; return; }
      btn.dataset.btCartRecAdd = String(v.id);
      btn.disabled = !v.a;
      if (!shown || (!shown.a && v.a)) shown = v;
    });
    const meta = card.querySelector('[data-bt-meta]');
    if (meta && shown) meta.textContent = size + ' ' + yen(shown.p);
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-bt-cart-rec-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();

    const drawer = document.querySelector('cart-drawer');
    const section = btn.closest('.bt-cart-recs');
    const errEl = section && section.querySelector('[data-bt-cart-recs-error]');
    if (errEl) errEl.hidden = true;
    btn.setAttribute('aria-busy', 'true');

    try {
      const sections = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((s) => s.id)
        : [];
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.btCartRecAdd), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'add failed');

      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents(data);
      } else {
        window.location.href = root + 'cart';
      }
    } catch (_) {
      btn.removeAttribute('aria-busy');
      if (errEl) {
        errEl.textContent = failText;
        errEl.hidden = false;
      }
    }
  });
})();
